import { Component, ErrorInfo, ReactNode } from 'react'

type ErrorBoundaryProps = {
  children: ReactNode
  fallBackComponent: ReactNode
  resetCondition?: any
  error?: boolean
}

type StatePros = {
  hasError: boolean
  resetCondition: any
}

export default class ErrorBoundary extends Component<ErrorBoundaryProps, StatePros> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false, resetCondition: props.resetCondition }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true }
  }

  static getDerivedStateFromProps(props: ErrorBoundaryProps, state: StatePros) {
    if (props.resetCondition !== state.resetCondition) {
      return { hasError: false, resetCondition: props.resetCondition }
    }
    return null
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError || this.props.error) {
      return this.props.fallBackComponent
    }

    return this.props.children
  }
}
